import { Link } from 'react-router-dom';
import { MessageCircle, ArrowRight } from 'lucide-react';

export function ContactCTA() {
  return (
    <aside className="max-w-4xl mx-auto mt-16 px-4" aria-label="Kapcsolatfelvétel">
      <div className="bg-gradient-to-br from-orange-400 via-pink-400 to-purple-500 rounded-3xl p-8 md:p-12 shadow-2xl text-center relative overflow-hidden">
        {/* Decorative */}
        <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" aria-hidden="true" />
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2" aria-hidden="true" />

        <div className="relative z-10">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6 backdrop-blur-sm" aria-hidden="true">
            <MessageCircle className="w-8 h-8 text-white" />
          </div>
          <h2
            className="text-3xl md:text-4xl font-light text-white mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Szeretne időpontot foglalni?
          </h2>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            Vegye fel velem a kapcsolatot! Szívesen válaszolok kérdéseire és segítek megtalálni
            a legmegfelelőbb fejlesztési megoldást gyermeke számára.
          </p>
          <Link
            to="/kapcsolat"
            data-testid="cta-contact-btn"
            className="inline-flex items-center gap-2 bg-white text-purple-600 px-8 py-4 rounded-full font-medium text-lg hover:bg-gray-50 transition-all duration-200 hover:scale-105 shadow-lg no-underline"
          >
            Kapcsolatfelvétel
            <ArrowRight className="w-5 h-5" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </aside>
  );
}
